import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'DrawSword',
    description: 'Original drawings, prints and custom commissions, drawn by hand and shipped from South Africa.',
    url: getOrigin()
}
